var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31109 7.29167L8.12945 8.75L10.3239 11.4583H1.71484V13.5417H10.3239L8.12945 16.25L9.31109 17.7083L13.5312 12.5L9.31109 7.29167ZM16.9073 19.7917H10.1551V21.875H16.9073C17.8358 21.875 18.5954 20.9375 18.5954 19.7917V5.20833C18.5954 4.0625 17.8358 3.125 16.9073 3.125H10.1551V5.20833H16.9073V19.7917Z",
    fill: "#B41411"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2567,
    height: 25,
    fill: "white",
    transform: "translate(0.0268555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e47a2f987dea2a110463527b28dd90ee.svg";
export { ForwardRef as ReactComponent };